/**
 * 联系人备注（v3.10）：本地个性化显示名，键 peerId → 备注。
 * 备注仅存本机 localStorage，不上链、不同步——避免被对方改名覆盖，
 * 也避免把用户隐私写进服务端。
 */
const CONTACT_NOTES_KEY = 'mesh_contact_notes_v1';

export interface ContactNotes {
  [peerId: string]: string;
}

export function loadContactNotes(): ContactNotes {
  try {
    const raw = localStorage.getItem(CONTACT_NOTES_KEY);
    if (!raw) return {};
    const obj = JSON.parse(raw) as Record<string, unknown>;
    const out: ContactNotes = {};
    for (const [k, v] of Object.entries(obj)) {
      if (typeof v === 'string' && v.trim()) out[k] = v.trim();
    }
    return out;
  } catch {
    return {};
  }
}

export function saveContactNote(peerId: string, note: string): ContactNotes {
  const notes = loadContactNotes();
  const trimmed = note.trim();
  if (trimmed) notes[peerId] = trimmed;
  else delete notes[peerId];
  try {
    localStorage.setItem(CONTACT_NOTES_KEY, JSON.stringify(notes));
  } catch {
    /* 存储满/禁用时静默 */
  }
  return notes;
}

/** 展示名：备注 → 昵称 → did/peerId 短码。 */
export function resolveContactName(
  note: string | undefined,
  fallback: string,
): string {
  if (note?.trim()) return note.trim();
  return fallback;
}
